var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"lesson-link",attrs:{"to":{
    name: 'Lessons',
    params: { lesson_id: _vm.lesson.id },
  }}},[_vm._v(" "+_vm._s(_vm.lesson.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }